module.exports = __webpack_public_path__ + "img/14_22.1747e94f.png";